import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Auth from '@aws-amplify/auth';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Logo from './Logo';

const useStyles = makeStyles({
  appBar: {
    backgroundColor: '#faab4b'
  },
  navButton: {
    maxWidth: '40%',
    margin: '0 0 0 auto'
  },
  navSignOut: {
    color: 'white'
  }
});

async function signOut() {
  try {
    await Auth.signOut();
  } catch (error) {
    console.log('error signing out: ', error);
  }
}

function Header() {
  const classes = useStyles();

  return (
    <AppBar className={classes.appBar} position="static">
      <Toolbar>
        <Logo />
        <Button className={classes.navButton} onClick={() => signOut()}>
          <Typography className={classes.navSignOut}>サインアウト</Typography>
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
